import React from "react";
import cx from "classnames";

import "./custom-menu.styles.scss";

type CustomMenuProps = {
  customMenuPositioning: {
    top: number;
    left: number;
  };
  useDefaultPosition?: boolean;
  className: string;
};
export const CustomMenu = ({
  customMenuPositioning,
  className,
  useDefaultPosition,
  ...rest
}: CustomMenuProps) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [positions, setPositions] = React.useState<{
    top: number;
    left: number;
  }>();

  const calculateMenuTopPosition = (current: HTMLDivElement) => {
    if (current) {
      const { top, height } = current.getBoundingClientRect();

      const bodyRect = document.body.getBoundingClientRect();
      const offset = top - bodyRect.top;

      return {
        left: customMenuPositioning.left,
        top:
          offset > bodyRect.height / 2
            ? top - height
            : customMenuPositioning.top,
      };
    }
  };

  React.useEffect(() => {
    if (ref.current && !useDefaultPosition) {
      setPositions(calculateMenuTopPosition(ref.current));
    }
  }, [useDefaultPosition]);

  return (
    <div
      {...rest}
      className={cx("ActionsButton__custom-menu", className)}
      style={{
        ...positions,
      }}
      ref={ref}
    />
  );
};
